import React from "react";
export const headers = ["Today", "Monthly", "Yearly"];

export const columns = [
  { label: "Current Date", key: "current_date_data" },
  { label: "Last Year Date", key: "last_yr_date_data" },
  { label: "Variation", key: "date_variation" },

  { label: "Current Month", key: "current_month_data" },
  { label: "Last Year Month", key: "last_year_month_data" },
  { label: "Variation", key: "month_variation" },

  { label: "Current FY ", key: "current_fy_data_till_date" },
  { label: "Last FY ", key: "last_fy_data" },
  { label: "Variation", key: "fy_variation" },
];

export const getRows = (
  apiData,
  apiData1,
  apiData2,
  apiData3,
  apiData4,
  apiData5,
  apiData6,
) => {
  return [
    ///////////////////APIDATA/////////////////////

    {
      id: 1,
      label: "LOADING IN MT",
      key: "total",
      source: apiData5,
    },
    {
      id: 2,
      label: "LOADING IN WGN",
      key: "ldng",
      source: apiData1,
    },
    { id: 3, label: "TAKEN OVER [TRAINS]", key: "TRAIN_TO", source: apiData },
    { id: 4, label: "HANDED OVER [TRAINS]", key: "TRAIN_HO", source: apiData },
    {
      id: 5,
      label: "TOTAL TRSN [TRN]",
      key: "Total_Transaction_Trains",
      source: apiData,
    },
    ////////////////APIDATA1 057/////////////////
    { id: 6, label: "TAKEN OVER [WGN]", key: "rcpts", source: apiData1 },
    { id: 7, label: "HANDED OVER [WGN]", key: "dspts", source: apiData1 },

    { id: 8, label: "DIFFERENCE [WGN]", key: "diff", source: apiData1 },

    {
      id: 9,
      label: "TOTAL TRSN [WGN]",
      key: "Total_Transaction",
      source: apiData1,
    },
    { id: 10, label: "DWB-Y-DAY", key: "yday", source: apiData1 },
    { id: 11, label: "DWB-T-DAY", key: "today", source: apiData1 },
    { id: 12, label: "WTR", key: "WTR", source: apiData1 },

    //////////////////////APIDATA2 17////////////////////////////////

    { id: 13, label: "DSL LOCO HOLDINGS", key: "hldg_dsl", source: apiData2 },
    {
      id: 14,
      label: "DSL LOCO OUTAGE",
      key: "goods_outg_dsl",
      source: apiData2,
    },
    { id: 15, label: "DSL LOCO KMs", key: "km_dsl_total", source: apiData2 },
    { id: 16, label: "DSL LOCO USAGE", key: "ekm_dsl", source: apiData2 },
    { id: 17, label: "DSL LOCO LE%", key: "le_prct_dsl", source: apiData2 },

    { id: 18, label: "ELCT LOCO HOLDINGS", key: "hldg_elec", source: apiData2 },
    {
      id: 19,
      label: "ELCT LOCO OUTAGE",
      key: "goods_outg_elec",
      source: apiData2,
    },
    { id: 20, label: "ELCT LOCO KMs", key: "km_elec_total", source: apiData2 },
    { id: 21, label: "ELCT LOCO USAGE", key: "ekm_elec", source: apiData2 },
    { id: 22, label: "ELCT LOCO LE%", key: "le_prct_elec", source: apiData2 },
    //////////////////////////////////////////////////////////////////
    {
      id: 23,
      label: "Avg Speed(Ex Stb & Yd Tm)",
      key: "excl",
      source: apiData3,
    },
    {
      id: 24,
      label: "Avg Speed(In Stb & Yd Tm)",
      key: "incl",
      source: apiData3,
    },
    { id: 25, label: "NBOX IRE %", key: "percentage", source: apiData6 },
    { id: 26, label: "JUMBO IRE %", key: "percentage2", source: apiData6 },
    { id: 126, label: "BTPN IRE %", key: "percentage1", source: apiData6 },
    {
      id: null,
      label: "TERMINAL DET (LOADING)",
      key: "Head",
      source: apiData4,
    },
    {
      id: 27,
      label: "AVG  (RAKE/DAY)",
      key: "total_rake_loading",
      source: apiData4,
    },
    {
      id: 28,
      label: "AVG  (ARR TO PLC)",
      key: "arrival_to_placement_loading",
      source: apiData4,
    },
    {
      id: 29,
      label: "AVG  (PLC TO REL)",
      key: "placement_to_release_loading",
      source: apiData4,
    },
    {
      id: 30,
      label: "AVG  (REL TO DEP)",
      key: "release_to_departure_loading",
      source: apiData4,
    },
    {
      id: 31,
      label: "AVG  (TOTAL DET)",
      key: "Total_Detention_Loading",
      source: apiData4,
    },
    {
      id: null,
      label: "TERMINAL DET (UNLOADING)",
      key: "Head",
      source: apiData1,
    },
    {
      id: 32,
      label: "AVG  (RAKE/DAY)",
      key: "total_rake_unloading",
      source: apiData4,
    },
    {
      id: 33,
      label: "AVG  (ARR TO PLC)",
      key: "arrival_to_placement_unloading",
      source: apiData4,
    },
    {
      id: 34,
      label: "AVG  (PLC TO REL)",
      key: "placement_to_release_unloading",
      source: apiData4,
    },
    {
      id: 35,
      label: "AVG  (REL TO DEP)",
      key: "release_to_departure_unloading",
      source: apiData4,
    },
    {
      id: 36,
      label: "AVG  (TOTAL DET)",
      key: "Total_Detention_Unloading",
      source: apiData4,
    },
    //////////////////////////////////////////////////////////////////
    {
      id: null,
      label: "Commodity Wise Loading(in MT)",
      key: "Head1",
      source: apiData5,
    },
    {
      id: 37,
      label: "COAL (Ex Imp COAL)",
      key: "coal_excl_imported_coal_",
      source: apiData5,
    },
    {
      id: 38,
      label: "R/MAT.S.P.(Ex. IORE)",
      key: "r_mat_s_p_except_iron_ore_",
      source: apiData5,
    },
    {
      id: 39,
      label: "Iron Ore",
      key: "iron_ore",
      source: apiData5,
    },
    {
      id: 40,
      label: "Cement (Ex Clinker)",
      key: "cement_excl_clinker_",
      source: apiData5,
    },
    {
      id: 41,
      label: "Clinker",
      key: "clinker",
      source: apiData5,
    },
    {
      id: 42,
      label: "Food Grains",
      key: "food_grains",
      source: apiData5,
    },
    {
      id: 43,
      label: "Fertilizers",
      key: "fertilizers",
      source: apiData5,
    },
    {
      id: 44,
      label: "Container Domestic",
      key: "container_domestic",
      source: apiData5,
    },
    {
      id: 45,
      label: "Container Exim",
      key: "container_exim",
      source: apiData5,
    },
    {
      id: 46,
      label: "Empty Flat Wagons",
      key: "empty_flat_wagons",
      source: apiData5,
    },
    {
      id: 47,
      label: "Balance Other Goods",
      key: "balance_other_goods",
      source: apiData5,
    },
    {
      id: 48,
      label: "Total",
      key: "total",
      source: apiData5,
    },
    //////////////////////////////////////////////////////////////////
  ];
};
